import React from 'react';

const pageTitle = props => (
    <div className="page-title">
        <div className="container">
            <div className="row flex-center-y justify-between">
                <div className="col-xs-12 text-center">
                    <h1 className="color-grey capitalize">{ props.title }</h1>
                </div>
            </div>
        </div>
    </div>
);

export default pageTitle;


// WEBPACK FOOTER //
// ./src/components/UI/PageTitle.js